import React, { Component, Fragment } from 'react';
import Rating from 'react-rating';
import {
	Row,
	Col,
	Button,
    Label,
    Input,
	InputGroup,
	InputGroupAddon
} from 'reactstrap';

import { connect } from 'react-redux';
import { Typeahead } from 'react-bootstrap-typeahead';
import {
	updateProvider,
	updateMapProvider,
	fetchOrderBids,
	confirmOrderBid,
    setOrderPublicPool,
    setOrderPrivatePool,
	cancelOrderBid,
	clearBids,
    find,
	findOrderWithAvaliableProviders,
    updateShopper,
    getOrderFleets,
    setOrderFleet
} from '../../store/actions/orderActions';
import { fetchProviders,clearProviders } from '../../store/actions/providerActions';
import { fetchCompanyBranches } from '../../store/actions/branches/branchActions';
import { utcDateFormat,dimenImg,providerOnline } from '../../store/actions/UtilsOperation';
import { COMPANY_ACCESS } from '../../constants/general';
import { ADMIN_OWNER } from '../../constants/bitwiseOperations';
import Spinner from '../../components/Spinner';
import { urlImg } from '../../config';

class ModalAssignProvider extends Component {

    constructor(props) {
        super(props);
        // this.state = ({
        //     selected: 0,
        //     userBranches: [...this.props.session.accesses].filter(e => e.access_type === "branch" && e.id !== String(this.props.branch.id))
        // })
        this.state = ({
            loading: true,
            userBranches: [],
            selected: 0,
            providers: [],
            loadingProviders: true,
            isShopperType: false,
            toggleFleetEdit: false,
            fleetName: ""
        })
        if (this.props.orderID) {
            this.loadOrderData();
        }
    }

    async loadOrderData() {
        try {
            const orderID = this.props.orderID;
            await this.props.find(orderID).then(() => {
                if(this.props.order && this.props.order.service_charge){
                    this.setState({
                        fleetName: this.props.order.service_charge.description
                    });
                }
                this.props.getOrderFleets(orderID);
            });

            await this.props.fetchCompanyBranches(100).then(() => this.listOfUserBranches());

            if(this.props.order.status_data.is_shopper_allowed && !this.props.order.status_data.shopper_assigned){
                let query = `is_shopper=1`;
                await this.props.fetchProviders(`${query}`).then(() => {
                    const { providers } = this.props;
                    this.setState({
                        providers: providers.data || providers || [],
                        loadingProviders: false,
                        isShopperType: true
                    });
                });
            }else{
                let query = `is_deliverer=1`;
                if(this.props.orderFleets && this.props.orderFleets.length > 0){
                    query = `order_id=${orderID}`;
                }
                await this.props.fetchProviders(`${query}`).then(() => {
                    const { providers } = this.props;
                    this.setState({
                        providers: providers.data || providers || [],
                        loadingProviders: false,
                        isShopperType: false
                    });
                });
            }

            this.props.fetchOrderBids(orderID);
            this.setState({ loading: false });
        } catch (error) {
            console.error("Error al cargar datos del orden: ", error);
        }
    }

    componentDidUpdate(prevProps){
        const { order } = this.props;
        const { isShopperType } = this.state;
        if(prevProps.order !== order){
            if(order && order.id){
                if(isShopperType){
                    if(order.is_shopper_assigned || order.is_status_completed){
                        if(this.props.reference){ this.props.reference() }
                    }
                } else{
                    if(order.is_provider_assigned || order.is_status_completed){
                        if(this.props.reference){ this.props.reference() }
                    }
                }
            }
        }
    }

    listOfUserBranches(){
        let newList = [];
        const { branches,userHigherAccess,session } = this.props;

        if (userHigherAccess === COMPANY_ACCESS || session.account.type === ADMIN_OWNER){
            newList = [...branches].map(b => {
                return { access_id: b.id, related_access: {...b} };
            }).filter(b => {
                return b.access_type !== 'company'
            })
        }
        else {
            newList = [...branches].map(b => {
                let finded = this.state.userBranches.findIndex(ub => ub.access_type === "branch" && ub.access_id === b.id)

                return finded !== -1 ? { access_id: b.id, related_access: {...b} } : null;
            }).filter( b => b) // devuelve los que no son nulos
        }
        this.setState({
            //loading: false,
            userBranches: newList
         })

    }

    componentWillUnmount () {
        //? vaciar los repartidores afectaba a los marcadores del mapa: this.props.clearProviders()
        this.props.clearBids()
        this.setState({
            selected: 0
        })
    }

    close = () => {
        if(this.props.refresh){ this.props.refresh() }
        if(this.props.reference){ this.props.reference() }
        this._typeahead.getInstance().clear();
    }

    assignAndClose = () => {
		if(this.props.isMapViewModal){
			this.props.updateMapProvider(this.props.selectedOrder, this.state.selected).then((res) => {
				this.close()
			}).catch( (err) => {
			console.log("error al acualizar form ",err)
			});
		}
		else {
            if(this.props.order.status_data.is_shopper_allowed && !this.props.order.status_data.shopper_assigned){
                this.props.updateShopper(this.props.orderID, this.state.selected,'put').then(() => {
                    this.props.fetchOrderBids(this.props.orderID).then(() =>{
                        if(this.props.bids && this.props.bids.length === 0){
                            this.close()
                        }
                    });
                }).catch( (err) => {
                console.log("error al acualizar form ",err)
                });
            }else{

                this.props.updateProvider(this.props.orderID, this.state.selected).then(() => {
                    this.props.fetchOrderBids(this.props.orderID).then(() =>{
                        if(this.props.bids && this.props.bids.length === 0){
                            this.close()
                        }
                    });
                }).catch( (err) => {
                console.log("error al acualizar form ",err)
                });
            }
		}
    }

    assignShopperAndClose = () => {
		if(this.props.isMapViewModal){
			this.props.updateMapProvider(this.props.selectedOrder, this.state.selected).then((res) => {
				this.close()
			}).catch( (err) => {
			console.log("error al acualizar form ",err)
			});
		}
		else {
			this.props.updateShopper(this.props.orderID, this.state.selected,'put').then( (res) => {
				this.close()
			}).catch( (err) => {
			console.log("error al acualizar form ",err)
			});
		}
    }

    confirmAndClose = (id) => {
        this.props.confirmOrderBid(id).then( () => {
            if(!this.props.errorBids){
                this.close()
            }
        })
    }

    changePoolAndClose = (pool,id) => {
        this.props[pool](id).then( (res) => {
            this.close()
        }).catch( (err) => {
           console.log("error al acualizar form ",err)
        });
    }

    onChange = (target) => {
        let { name, value } = target,
            data = {
                'name': name,
                'data': value
            };
        this.setState({
            selected: data.data
        });
    }

    handleFleetChange = ({ value }) => {
        this.setState({ loadingProviders: true });
        if(value === "all"){
            this.setState({ fleetName: "Asignación manual" });
            if(this.props.order.status_data.is_shopper_allowed && !this.props.order.status_data.shopper_assigned){
                this.props.fetchProviders(`is_shopper=1`).then(() => {
                    const { providers } = this.props;
                    this.setState({
                        providers: providers.data || providers || [],
                        loadingProviders: false
                    });
                });
            }else{
                this.props.fetchProviders(`is_deliverer=1`).then(() => {
                    const { providers } = this.props;
                    this.setState({
                        providers: providers.data || providers || [],
                        loadingProviders: false
                    });
                });
            }
        }else {
            this.props.setOrderFleet(this.props.orderID, value).then(() => {
                let fleet = this.props.orderFleets.find((fleet) => fleet.id === Number(value));
                this.setState({ fleetName: fleet.description || "Asignación manual" });
                if(this.props.order.status_data.is_shopper_allowed && !this.props.order.status_data.shopper_assigned){
                    this.props.fetchProviders(`order_id=${this.props.orderID}`).then(() => {
                        const { providers } = this.props;
                        this.setState({
                            providers: providers.data || providers || [],
                            loadingProviders: false
                        });
                    });
                }else{
                    this.props.fetchProviders(`order_id=${this.props.orderID}`).then(() => {
                        const { providers } = this.props;
                        this.setState({
                            providers: providers.data || providers || [],
                            loadingProviders: false
                        });
                    });
                }
            });
        }
    }

    render() {
        const { company,json_lang,admin_type,branch,order, orderFleets, companyColor } = this.props;
        const { providers, loadingProviders, toggleFleetEdit, fleetName } = this.state;
        const { selected } = this.state;

        return <Fragment>
            {
                toggleFleetEdit ? (
                    <div className="d-flex align-items-start">
                        <i 
                            className="fa fa-arrow-left text-primary font-2xl pointer mt-1"
                            disabled={loadingProviders}
                            onClick={() => this.setState({ toggleFleetEdit: false })}
                        />
                        <div className="d-flex flex-column w-100">
                            {
                                orderFleets && orderFleets.length > 0 ? (
                                    <Row className=" d-flex flex-column justify-content-center m-2">
                                        <Label for="fleets">Flotas</Label>
                                        <Input
                                            onChange={(e) => this.handleFleetChange(e.target)}
                                            id="fleets"
                                            name="fleets"
                                            type="select"
                                            defaultValue={fleetName === "Asignación manual" ? "all" : order.service_charge.id}
                                        >
                                            {/* <option value={"all"}>{this.props.json_lang.modal_assign_order.manual_assignment}</option> */}
                                            {orderFleets.map((fleet) => {
                                                let label = 'Flota';
                                                if(fleet && fleet.description){
                                                    label = fleet.description;
                                                }else if(fleet && fleet.service_supplier && fleet.service_supplier.internal_name){
                                                    label = fleet.service_supplier.internal_name;
                                                }
                                                return (
                                                    <option
                                                        key={fleet.id}
                                                        value={fleet.id}
                                                    >
                                                        {label}
                                                    </option>
                                                )
                                            }

                                            )}
                                        </Input>
                                    </Row>
                                ) : (
                                    <span className='text-muted'>No existen flotas asignadas a este comercio</span>
                                )
                            }
                            {
                                providers.length > 0 && !loadingProviders ?
                                <span className='text-muted'>Se {providers.length === 1 ? 'encontró' : 'encontraron'} {providers.length} {providers.length === 1 ? 'repartidor' : 'repartidores'}</span>
                                : <span className='text-muted'>
                                    {loadingProviders ? "Cargando..." : "No se encontraron repartidores con los parámetros actuales"}
                                </span>
                            }
                        </div>
                    </div>
                ) : (
                    <Fragment>
                        <Row className="justify-content-center">
                            <Col>
                                {
                                    this.props.bids && this.props.bids.length > 0?
                                    <Fragment>
                                        <h6>{this.props.json_lang.order_details.waiting_confirmation_msg}</h6>
                                        <ul style={{maxHeight:'200px',width:'100%',overflow: 'auto'}}>
                                            {
                                                this.props.bids.map( (bid, key) => {

                                                    let BID_AVAILABLE = (bid.status&2) !== 0;
                                                    let MASK_NEEDS_CONFIRMATION = (bid.status & 1092) !== 0;
                                                    let BID_ADMIN_CONFIRMS = (bid.status&4) !== 0;
                                                    let BID_PROVIDER_CONFIRMS = (bid.status & 64) !== 0;
                                                    let BID_CLIENT_CONFIRMS = (bid.status & 1024) !== 0;
                                                    let BID_REFUSED = (bid.status&1) !== 0;

                                                    let btn;

                                                    if (BID_AVAILABLE && MASK_NEEDS_CONFIRMATION) {

                                                        if (BID_PROVIDER_CONFIRMS) {
                                                            btn = <Fragment>
                                                                <Button color="ghost-danger" className="btn-sm float-right" title="Cancelar posibilidad del proveedor de tomar esta orden" onClick={() => this.props.cancelOrderBid(bid.id)}>
                                                                    <i className='icon-close'></i>
                                                                </Button>
                                                            </Fragment>
                                                        }

                                                        else if( BID_ADMIN_CONFIRMS ){
                                                            btn = <Fragment>
                                                                <Button color="ghost-success" className="btn-sm float-right" title="Asignarle la orden" onClick={ ()=>this.confirmAndClose(bid.id) }>
                                                                    <i className='icon-check'></i>
                                                                </Button>
                                                                <Button color="ghost-danger" className="btn-sm float-right" title="Cancelar posibilidad del proveedor de tomar esta orden" onClick={() => this.props.cancelOrderBid(bid.id)}>
                                                                    <i className='icon-close'></i>
                                                                </Button>
                                                            </Fragment>
                                                        }

                                                        else if (BID_CLIENT_CONFIRMS) {
                                                            btn = <div color="ghost-danger" className="btn-sm float-right">{this.props.json_lang.order_details.bid_waiting_client_confirm_msg}</div>
                                                        }
                                                    }

                                                    if( BID_REFUSED) {
                                                        btn = <div color="ghost-danger" className="btn-sm float-right">{this.props.json_lang.order_details.bid_rejected_msg}</div>
                                                    }

                                                    return <li key={key} className={ 'custom_detail_orden' }>
                                                        <b className={ 'text-info' } style={{display: 'inline-block',width: 'calc(100% - 180px)'}}>Asignado el {utcDateFormat(bid.created_at,'fromNow')}</b>
                                                            <Button
                                                                color="ghost-success"
                                                                className="btn-sm float-right"
                                                                title={this.props.json_lang.order_details.bid_force_asignation_msg}
                                                                onClick={() => this.confirmAndClose(bid.id)} //confirmOrderBid
                                                            >
                                                                <i className='icon-check'></i>
                                                            </Button>
                                                            {btn}
                                                        <div className="py-3 mr-2 ml-2 float-left">
                                                            <img id={`provider-avatar-${bid.provider.id}`}
                                                                className="avatar_small"
                                                                src={bid.provider.avatar_url ? dimenImg(bid.provider.avatar_url,'36x36','jpg') : `${urlImg}avatar.png` }
                                                                onError={ ()=> document.getElementById(`provider-avatar-${bid.provider.id}`).src= `${urlImg}avatar.png` }
                                                                alt={ bid.provider.id} />
                                                        </div>

                                                        <div>
                                                            <b>{bid.provider.name} </b>
                                                            ({
                                                                ( parseInt(bid.provider.status & 18,10) )!== 0 ?
                                                                    this.props.json_lang.order_details.provider_busy_label
                                                                :
                                                                    this.props.json_lang.order_details.provider_available_label
                                                            })
                                                        </div>
                                                        {
                                                            bid.provider.email != null ?
                                                                <small className="text-muted">
                                                                    <b>{this.props.json_lang.common.email}: </b>
                                                                    {bid.provider.email } <br/>
                                                                </small>
                                                            :'-'
                                                        }
                                                        {
                                                            bid.provider.phone != null ?
                                                                <small className="text-muted">
                                                                    <b>{this.props.json_lang.common.phone}: </b>
                                                                    { bid.provider.phone } <br/>
                                                                </small>
                                                            :'-'
                                                        }
                                                        {
                                                            bid.provider_e2 > 0?
                                                                <small className="text-muted" style={{display:'inline-block'}}>
                                                                    <b>{this.props.json_lang.common.rating}: </b>
                                                                    <Rating
                                                                        emptySymbol="fa fa-star-o"
                                                                        fullSymbol="fa fa-star"
                                                                        initialRating={ bid.provider_e2 /100 }
                                                                        readonly />
                                                                </small>
                                                            :null
                                                        }
                                                    </li>
                                                })
                                            }
                                        </ul>
                                    </Fragment>
                                    : <h6 className="text-muted">
                                        {providers.length > 0 &&
                                            ( order.status_data && order.status_data.is_shopper_allowed && !order.status_data.shopper_assigned ?
                                                this.props.json_lang.map_view.unassigned_shopper_msg :
                                                this.props.json_lang.map_view.unavaliable_shopper_messg
                                            ) ||
                                            (this.props.json_lang.map_view.unassigned_provider_msg || this.props.json_lang.map_view.unavaliable_provider_msg)
                                            }
                                    {
                                        /*branch && branch.name?
                                            <span className="text-primary" style={{cursor: 'pointer'}}
                                                onClick={()=>this.changePoolAndClose( (order.status_data && order.status_data.pool_is_private ? 'setOrderPublicPool':'setOrderPrivatePool'),this.props.orderID)}>
                                                {` Enviar al pool de ${order.status_data && order.status_data.pool_is_private ? branch.name : company.name}`}
                                            </span>
                                        :setOrderPublicPool setOrderPrivatePool &&*/
                                        order &&
                                        <span className="text-primary" style={{cursor: 'pointer'}}
                                            onClick={()=>this.changePoolAndClose( (order && order.status_data && order.status_data.pool_is_private === true ? 'setOrderPublicPool' : 'setOrderPrivatePool'),this.props.orderID)}>
                                            {` Enviar al pool de ${order && order.status_data && order.status_data.pool_is_private ?  company.name : (branch.name ? branch.name : 'comercio' ) }`}
                                        </span>
                                    }

                                    </h6>
                                }
                            </Col>
                        </Row>

                        {
                        this.state.loading ?
                            <Row className="justify-content-center">
                                <Spinner size='34px' color={companyColor} />
                            </Row>
                        :
                        <Fragment>
                            {
                                this.props.order.status_data.is_shopper_allowed && !this.props.order.status_data.shopper_assigned ? null : (
                                    <Row>
                                        <Col>
                                            <h3 className="text-center font-weight-bold mt-2">
                                                {fleetName}
                                            </h3>
                                        </Col>
                                    </Row>
                                )
                            }
                            {providers.length > 0 && !loadingProviders ?
                            <Fragment>
                                <Row className="justify-content-center">
                                    <Col>
                                        <InputGroup>
                                            <Typeahead
                                                className='iniline-select'
                                                labelKey="name"
                                                multiple={false}
                                                ref={(ref) => this._typeahead = ref}
                                                emptyLabel={this.props.json_lang.common.no_results_msg}
                                                options={ providers }
                                                onChange={(selected) => this.setState({ selected: selected[0] && selected[0].id ? selected[0].id : 0 })}
                                                placeholder={
                                                    this.props.order.status_data.is_shopper_allowed && !this.props.order.status_data.shopper_assigned 
                                                    ? this.props.json_lang.modal_assign_order.shopper_searchbox_placeholder
                                                    : this.props.json_lang.modal_assign_order.provider_searchbox_placeholder
                                                }
                                                filterBy={['email', 'name', 'display_name', 'phone']}
                                                renderMenuItemChildren={(option, props, index) => {

                                                    return <Fragment key={index}>
                                                        <div className="mr-3 float-left">
                                                            <img className="avatar_small" src={option.avatar_url ? dimenImg(option.avatar_url,'36x36','jpg') : `${urlImg}avatar.png`}
                                                                id={`avatar_small-${option.id}`}
                                                                onError={ ()=> document.getElementById(`avatar_small-${option.id}`).src= `${urlImg}avatar.png` }
                                                                alt={option.name ? option.name : ''} />
                                                        </div>
                                                        {
                                                            option.distance_in_meters && (
                                                                <div className="float-right">
                                                                    <small className='badge badge-primary'>
                                                                        {(option.distance_in_meters / 1000).toFixed(1)} km
                                                                    </small>
                                                                </div>
                                                            )
                                                        }
                                                        {/* {
                                                            option.orders_count && (
                                                                <div className="float-right">
                                                                    <small className='badge badge-primary'>
                                                                        {option.orders_count} {this.props.json_lang.common.orders}
                                                                    </small>
                                                                </div>
                                                            )
                                                        } */}
                                                        <div key="name" >
                                                            <b>{option.name ? option.name : ''}{option.is_busy ? ` (${this.props.json_lang.order_details.provider_busy_label})` : ""}</b>
                                                            <small className={'text-muted'} key="email" style={{display:'block'}}>
                                                                {option.email ? option.email : ''}
                                                            </small>
                                                            {
                                                                option.orders_count ? (
                                                                    <div className="d-flex flex-row justify-content-start mt-1">
                                                                        <span 
                                                                            className='badge badge-primary position-relative'
                                                                            style={{
                                                                                position: 'relative',
                                                                                right: '0',
                                                                                marginTop: '0'
                                                                            }}
                                                                        >
                                                                            {option.orders_count} {option.orders_count === 1 ? this.props.json_lang.common.order.toLowerCase() : this.props.json_lang.common.orders.toLowerCase()}
                                                                        </span>
                                                                    </div>
                                                                ) : null
                                                            }
                                                        </div>
                                                        {
                                                            option.accesses && option.accesses.length > 0 ?
                                                                option.accesses.map((access, key) => {
                                                                    let bAcces = this.state.userBranches.find( (b,i) =>{
                                                                        return b.access_id === access.access_id
                                                                    });
                                                                    const relatedAccessName= `${json_lang.common.branch} : ${bAcces && bAcces.related_access && bAcces.related_access.name}`;
                                                                    return (
                                                                            <div key={key}>
                                                                                <span className="confirmed mt-1">
                                                                                    {
                                                                                        (admin_type === 2 && bAcces) ?
                                                                                            relatedAccessName
                                                                                        :
                                                                                            access.access_type  ===  `App\\Company` ? company.name : relatedAccessName
                                                                                    }
                                                                                </span>
                                                                            </div>
                                                                        )
                                                                })
                                                            :null
                                                        }
                                                    </Fragment>
                                                }}/>
                                            <InputGroupAddon addonType="append">
                                                <Button color="primary iniline-select-btn"
                                                    style={this.props.bg_company ? this.props.bg_company : undefined}
                                                    title={this.props.json_lang.common.add}
                                                    onClick={() => this.assignAndClose()}
                                                    disabled={ selected === 0 }
                                                >
                                                    {this.props.json_lang.common.add}
                                                </Button>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </Col>
                                </Row>
                            </Fragment>
                            :
                                <div className="d-flex justify-content-center">
                                    <span className='text-danger'>
                                        No se encontraron providers con los parámetros actuales
                                    </span>
                                </div>
                            }
                            {
                                this.props.order.status_data.is_shopper_allowed && !this.props.order.status_data.shopper_assigned ? null : (
                                    <div className="text-center mt-3">
                                        <Button
                                            onClick={() => this.setState({ toggleFleetEdit: true })}
                                            color="primary"
                                        >
                                            Cambiar flota
                                        </Button>
                                    </div>
                                )
                            }
                        </Fragment>
                        }
                    </Fragment>
                )
            }
            
        </Fragment>
    }
}

const mapStateToProps = (state) => {
    let allProviders = state.providers;

    let admin_type_ID = state.session && state.session.admin_type && state.session.admin_type.id ? state.session.admin_type.id : "";
    //let alertt;
    let asignables =[]
    if(allProviders && allProviders.data && allProviders.data.length){
        asignables = allProviders && allProviders.data.filter( (asignable,key) => {

            let found;
            let isAsignable = asignable;
            if(state.bids){
                found = state.bids.find((bidsProvider) => bidsProvider.provider_id === asignable.id);
                //console.log('asignable0',asignable,state.bids)
                if(found){
                    isAsignable =  asignable.id !== found.provider_id
                }
            }
            return isAsignable
        }).filter( (asignable,key) => {
            return asignable && asignable.accesses && asignable.accesses.length >0;
        }).filter( (asignable,key) => {
            return (parseInt(asignable && asignable.account && asignable.account.status,10)&255)=== 240
        }).filter( (asignable,key) => {
            return providerOnline(asignable && asignable.status)
        })
    }
    let filteredproviders = asignables.filter((asignable,key) => {

        return asignable.accesses.some((access) => {
            if(state.order && state.order.status_data
                && state.order.status_data.pool_is_private === false
                && state.userHigherAccess === COMPANY_ACCESS){
                return access.access_type === `App\\Company`
            }else{
                return access.access_type !== `App\\Company`
            }
        });
    })

    if(state.hasFleets){
        filteredproviders = allProviders;
    }

    return {
        errors: state.errors,
        json_lang: state.json_lang,
        providers: filteredproviders,
        bids:state.bids,
        clearBids:state.clearBids,
        order:state.order,
        session: state.session,
        branches: state.branches,
        branch: state.branch,
        admin_type:admin_type_ID,
        company:state.company,
        userHigherAccess: state.userHigherAccess,
        orderFleets: state.orderFleets,
        errorBids: state.errorBids,
        companyColor: state.company.styles_json.styles.color_primary
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateProvider: (order, id) => dispatch(updateProvider(order, id)),
		updateMapProvider: (order, id) => dispatch(updateMapProvider(order, id)),
        updateShopper: (order, id,action) => dispatch(updateShopper(order, id,action)),
		fetchOrderBids: (id) => dispatch(fetchOrderBids(id)),
        fetchProviders: (query) => dispatch(fetchProviders(1,query)),
        fetchCompanyBranches: (limit) => dispatch(fetchCompanyBranches(limit)),
        confirmOrderBid: (id) => dispatch(confirmOrderBid(id)),
        setOrderPublicPool: (id) => dispatch(setOrderPublicPool(id)),
        setOrderPrivatePool: (id) => dispatch(setOrderPrivatePool(id)),
        cancelOrderBid: (id) => dispatch(cancelOrderBid(id)),
        clearProviders: (id) => dispatch(clearProviders(id)),
        clearBids: (id) => dispatch(clearBids(id)),
        findOrderWithAvaliableProviders: () => dispatch(findOrderWithAvaliableProviders()),
        find: (id) => dispatch(find(id)),
        getOrderFleets: (orderId) => dispatch(getOrderFleets(orderId)),
        setOrderFleet: (orderId, serviceChargeId) => dispatch(setOrderFleet(orderId, serviceChargeId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAssignProvider);



// WEBPACK FOOTER //
// ./src/views/Orders/modalAssignProvider.js